import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { merge } from 'lodash/fp';

import { GoogleSupportedLanguage } from 'dashboard/lib/constants/locales';
import { INQUIRY_LANGUAGES_ENGLISH, InquiryIso6391LanguageCode } from 'lib/constants/locales';

type TranslationsState = Translations;
export interface Translations {
  [sourceText: string]: Partial<{
    [locale in GoogleSupportedLanguage | InquiryIso6391LanguageCode]: string;
  }>;
}

// initialize translations object with empty strings for each locale
// to centralize updating the locale overrides when "auto-translating"
// from an empty string source text (we omit making any actual API calls).
const initialState: TranslationsState = {
  '': Object.keys(INQUIRY_LANGUAGES_ENGLISH).reduce(
    (acc, locale) => ({
      ...acc,
      [locale]: '',
    }),
    {},
  ),
};

const { reducer, actions } = createSlice({
  name: 'translations',
  initialState,
  reducers: {
    setTranslations: (state, action: PayloadAction<Translations>) => {
      return merge(state, action.payload);
    },
  },
});

export const { setTranslations } = actions;
export const translationsReducer = reducer;
